<template>
  <div>
    <span>应用范围</span>
    <v-select :data="appOptions"
              v-model="appValue"
              :allowClear="false"
              style="width: 200px;"></v-select>
    <span>所属板块</span>
    <v-select :data="adverOptions"
              v-model="adverValue"
              :allowClear="false"
              style="width: 200px;"></v-select>
    <v-button type="primary"
              @click="viewAdver">查看</v-button>
    <v-button type="warning"
              @click="save">保存修改</v-button>
    <div style="height:20px;"></div>
    <v-row v-if="searchFlag && showType === 'message'">
      <v-col span="12">
        <p>现有内容</p>
        <div style="height:20px;"></div>
        <span>状态:</span>
        <v-switch v-model="state"
                  disabled
                  :true-value="true"
                  :false-value="false">
          <span slot="checkedChildren">启动</span>
          <span slot="unCheckedChildren">禁用</span>
        </v-switch>
        <div style="height:20px;"></div>
        <v-input type="textarea"
                 v-model="message"
                 autosize
                 disabled
                 style="width:80%;min-height:200px;"></v-input>
        <div style="height:20px;"></div>
        <span>标题</span><br>
        <v-input style="width:80%;"
                 v-model="title"
                 disabled></v-input>
        <div style="height:20px;"></div>
        <img style="width:80%;height:200px;"
             :src="picUrl" />
        <div style="height:20px;"></div>
        <!-- <v-input style="width:80%;"
                 disabled
                 placeholder="请输入链接">
          <span slot="before">http://</span>
        </v-input> -->
      </v-col>
      <v-col span="12">
        <p>更新内容</p>
        <div style="height:20px;"></div>
        <span>状态:</span>
        <v-switch v-model="upState"
                  :true-value="true"
                  :false-value="false">
          <span slot="checkedChildren">启动</span>
          <span slot="unCheckedChildren">禁用</span>
        </v-switch>
        <div style="height:20px;"></div>
        <v-input type="textarea"
                 v-model="upMessage"
                 autosize
                 style="width:80%;min-height:200px;"></v-input>
        <div style="height:20px;"></div>
        <span>标题</span><br>
        <v-input style="width:80%;"
                 v-model="upTitle"></v-input>
        <div style="height:20px;"></div>
        <div style="width:80%;background-color:#f2f2f2;height:200px;"></div>
        <div style="height:20px;"></div>
        <!-- <v-input style="width:80%;"
                 placeholder="请输入链接">
          <span slot="before">http://</span>
        </v-input> -->
      </v-col>
    </v-row>
    <v-row v-if="searchFlag && showType === 'advertisement'">
      <v-col span="12">
        <p>现有内容</p>
        <div v-for="(item, index) in imgData"
             :key="index">
          <div style="height:20px;"></div>
          <img :src="item.img_url"
               style="width:400px;height:300px;" />
          <div style="height:20px;"></div>
          <span>跳转链接:</span>
          <v-input style="width:70%;"
                   disabled
                   :value="item.jump_url"></v-input>
        </div>
      </v-col>
      <v-col span="12">
        <p>更新内容</p>
        <div style="height:20px;"></div>
        <span>状态:</span>
        <v-switch v-model="upImgState"
                  :true-value="true"
                  :false-value="false">
          <span slot="checkedChildren">启动</span>
          <span slot="unCheckedChildren">禁用</span>
        </v-switch>
        <div style="height:20px;"></div>
        <div v-for="(item, i) in imputData"
             :key="i">
          <div style="height:20px;"></div>
          <v-upload :name="name"
                    :action="action"
                    :header="header"
                    @click.native="upClick(i)"
                    @change="onChange">
            <v-button type="ghost">
              <v-icon type="upload"></v-icon>上传图片
            </v-button>
          </v-upload>
          <img :src="item.url"
               style="width:400px;height:300px;" />
          <div style="height:20px;"></div>
          <span>跳转链接:</span>
          <v-input style="width:70%;"
                   v-model="item.jump_url"></v-input>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      header: { 'server-mode': this.$store.state.serverMode },
      name: 'img',
      action: '/dev/upload_img',
      appOptions: [],
      appValue: 'ALL',
      adverOptions: [],
      adverValue: '',
      searchFlag: false,
      showType: '',
      message: '',
      title: '',
      picUrl: '',
      upMessage: '',
      upTitle: '',
      state: null,
      upState: true,
      imgData: [],
      imputData: [],
      upImgState: true,
      tempid: 0
    }
  },
  methods: {
    upClick (i) {
      this.tempid = i
    },
    onChange (info) {
      console.log(info)
      if (info.file.status !== 'uploading') {
        this.$notification.warning({
          message: '警告',
          description: '上传中,请勿做其他操作',
          duration: 0,
          selfKey: 'noClose'
        })
      }
      if (info.file.status === 'done') {
        this.$notification.close('noClose')
        this.$notification.success({
          message: '成功',
          description: '上传成功'
        })
        console.log(info.file.response.show_url)
        this.imputData[this.tempid].url = info.file.response.show_url
        this.imputData[this.tempid].pic_url_key = info.file.response.key
      } else if (info.file.status === 'error') {
        this.$notification.close('noClose')
        this.$notification.success({
          message: '失败',
          description: '上传失败'
        })
      }
    },
    save () {
      if (!this.searchFlag) {
        this.$message['error']('请先查看')
        return
      }
      if (this.showType === 'message') {
        if (this.upTitle === '') {
          this.$message['error']('请输入要修改的标题')
          return
        }
        if (this.upMessage === '') {
          this.$message['error']('请输入要修改的内容')
          return
        }
        axios.post('/dev/advertisemen_info', {
          package_key: this.appValue,
          advertisemen_type: this.adverValue,
          data: {
            title: this.upTitle,
            message: this.upMessage,
            state: this.upState,
            pic_url_key: this.picUrl
          }
        }).then(res => {
          if (res.data.code === 200) {
            this.$message['success']('修改成功')
            this.viewAdver()
          }
        })
      } else {
        // 校验数据
        this.imputData.forEach(item => {
          if (item.pic_url_key === '') {
            this.$message['error']('请检查是否上传全部的图片')
            return
          }
          if (item.jump_url === '') {
            item.jump_url = null
          }
        })
        axios.post('/dev/advertisemen_info', {
          package_key: this.appValue,
          advertisemen_type: this.adverValue,
          data: {
            data: this.imputData,
            state: this.upImgState
          }
        }).then(res => {
          if (res.data.code === 200) {
            this.$message['success']('修改成功')
            this.viewAdver()
          }
        })
      }
    },
    viewAdver () {
      this.upImgState = true
      this.upMessage = ''
      this.upTitle = ''
      this.upState = true
      this.imputData = []
      if (this.adverValue === '') {
        this.$message['error']('请选择板块')
        return
      }
      axios.get('/dev/advertisemen_info?package_key=' + this.appValue + '&advertisemen_type=' + this.adverValue).then(res => {
        if (res.data.code === 200) {
          this.searchFlag = true
          this.showType = res.data.show_type
          if (this.showType === 'message') {
            this.message = res.data.data.message
            this.title = res.data.data.title
            this.picUrl = res.data.data.pic_url
            this.state = res.data.state
          } else {
            this.imgData = res.data.data
            res.data.data.forEach(item => {
              this.imputData.push({ url: '', jump_url: '', pic_url_key: '' })
            })
          }
        }
      })
    },
    getApps () {
      axios.get('/dev/package_info').then(res => {
        let arr = []
        res.data.package_info.forEach(item => {
          let obj = {}
          obj.value = item.value
          obj.label = item.key
          arr.push(obj)
        })
        this.appOptions = arr
      }).catch(err => { console.log(err) })
    },
    getAdversti () {
      axios.get('/dev/advertisemen_type?package_key=' + this.appValue).then(res => {
        let arr = []
        res.data.result.forEach(item => {
          let obj = {}
          obj.value = item.value
          obj.label = item.key
          arr.push(obj)
        })
        this.adverOptions = arr
      })
    }
  },
  mounted () {
    this.getApps()
    this.getAdversti()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/operation/operation.vue